import Button from "../../../../Control/Button";
import styled from "styled-components"

const ButtonRetry = styled(Button)`
    margin: 21px auto 0;
    width: 160px;
`;

export default ButtonRetry;